import React from 'react';

import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import Menu from 'ui-library/menus/Menu';
import SearchableMenu from 'ui-library/menus/SearchableMenu';
import {typeToName} from 'util/NameUtil';

interface Group {
  id: string;
  name: string;
}

interface Props<T extends Group> {
  className?: string;
  disabled?: boolean;
  selectedGroup: T | null;
  groups: Array<T>;
  onSelect: (group: T) => void;
  groupType: string;
}

/**
 * Presentational component for selecting teams or organizations.
 */
export default function GroupSelector<T extends Group>(props: Props<T>): JSX.Element {
  return (
    <SelectDropdown
      className={props.className}
      menu={
        <SearchableMenu
          height={Menu.HEIGHTS.MEDIUM}
          width={Menu.WIDTHS.FULL}
          selectedValue={props.selectedGroup}
          optionDatas={props.groups.map((group) => ({
            value: group,
            name: group.name,
          }))}
          onSelect={props.onSelect}
        />
      }
      disabled={props.disabled}
      displayName={
        props.selectedGroup != null ? props.selectedGroup.name : `Select ${typeToName(props.groupType)}...`
      }
    />
  );
}
